<template>
  <div class="payment-set">
    <div class="list">
      <router-link
        class="item acea-row row-between-wrapper"
        v-for="(item, index) in list"
        :key="index"
        :to="item.url ? item.url : ''"
      >
        <div class="name">{{ item.name }}</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { hasPassword } from "@/api/user";
export default {
  name: "PaymentSettings",
  data: function() {
    return {
      list: [
        {
          name: "支付密码",
          url: "/user/paymentset/modifyPayment"
        },
        {
          name: "银行卡",
          url: "/user/bank_manage"
        }
      ],
      formItem: 0
    };
  },
  mounted() {
    this.getPPasswd();
  },
  methods: {
    getPPasswd() {
      hasPassword({ type: 2 }).then(res => {
        if (res.data.set) {
          this.formItem = 2;
        } else {
          this.formItem = 1;
          this.list[0].url = "/user/paymentset/setPayment";
        }
      });
    }
  }
};
</script>
